import { Component, OnInit } from '@angular/core';
import { TarjetasService } from 'src/app/service/tarjetas.service';
import { LoginService } from 'src/app/service/login.service';
import { PerfilService } from 'src/app/service/perfil.service';
import { Session } from 'protractor';


@Component({
  selector: 'app-solicitudes',
  templateUrl: './solicitudes.component.html',
  styleUrls: ['./solicitudes.component.scss']
})
export class SolicitudesComponent implements OnInit {
  modal = false;
  session: any;
  solicitudes: any[] = [];
  cardSelected: any
  numeroSolicitud: any;
  user: any
  dni: any
  detalleSolicitud: any;
  fecha: any;
  fechaCreacion: string;
  fechaCreacionIso: string;
  errorMensaje: any;

  constructor(private tarjetas: TarjetasService, private perfil: PerfilService, private login: LoginService) {
    this.session = JSON.parse(localStorage.getItem('sesionPocae'))
    this.dni = this.session.dpi
  }

  ngOnInit() {
    this.tarjetas.selectedCard.subscribe(tarjetas => {
      this.cardSelected = tarjetas;
      this.getData();
    });
  }

  detalles(solicitud, tipo, fecha) {
    this.numeroSolicitud = solicitud;
    this.fecha = fecha;
    const json = {
      sesion: {
        sIdSesion: localStorage.getItem("KSI"),
        nIdUsuarioWeb: this.session.idUsuario,
        nIdEmpresa: 5,
        sHost: "127.0.0.1"
      },
      idSolicitud: solicitud
    }

    this.tarjetas.getDetalle(json).subscribe(res => {
      this.detalleSolicitud = res?.detalleSolicitud;
      this.fechaCreacion = this.detalleSolicitud?.fhoCreacion;
      this.fechaCreacionIso = this.fechaCreacion.replace(' ', 'T');
      this.show(true);
    }, () => {
      this.errorMensaje = "Error al obtener el detalle. Inténtelo más tarde.";
    })
  }

  getData() {
    const body = {
      sesion: {
        sIdSesion: localStorage.getItem("KSI"),
        nIdUsuarioWeb: this.session.idUsuario,
        nIdEmpresa: 5,
        sHost: "127.0.0.1"
      },
      dni: this.dni,
      idSolicitud: null,
      codtiposolicitud: '',
      fechaCreacionHasta: '',
      fechaCreacionDesde: '',
      tarjetaInternaOrigen: localStorage.getItem("numInt") || '',
      codestado: '',
      montosolicitado: null,
      codclasificacion: '',
      horaIncidente: '',
      fhoincidente: '',
      paginacion: {
        sOrdenarPor: 'idSolicitud',
        sOrden: 'ASC',
        nPagina: 1,
        nCantRegPorPag: 1000,
      }
    }
    
    this.tarjetas.getSolicitudes(body).subscribe(res => {
      this.solicitudes = res?.listaSolicitudes;
    }, () => {
      this.errorMensaje = "Error al obtener solicitudes. Inténtelo más tarde.";
    })
  }

  show(response: boolean) {
    this.modal = response;
  }
}
